module.exports = __webpack_public_path__ + "static/media/funnel_description_mobile.c26a71ed.png";